module.exports = __webpack_public_path__ + "first-500-ir.jpg?ffdb581627d5fd3bafe268a9107f0115";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500-ir.jpg
// module id = 542
// module chunks = 0